import { Type, CreateTypeRequest, CreateTypeResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export type { Type };
export const createType = makeCloudFunction<
  CreateTypeRequest,
  CreateTypeResponse
>("type", "createType");
